import Spinner from 'src/javascripts/components/utilities/Spinner';
import * as fileUpload from 'blueimp-file-upload/js/jquery.fileupload.js';
import ToggleNewData from './ToggleNewData';
import ToastCustom from '../../alerts/ToastCustom';

// Add documents in survey
export default function(parentContainer) {
  let accountUrl = $('body').attr('data-account-url');
  let surveySlug = $('.polling-indicator').attr('data-slug');

  parentContainer.find('.survey-document-filepicker').each(function(i, elem) {
    let fileInput     = $(elem);
    let filePicker    = $(this);
    let dropZone      = $(this).closest('.filepicker-container');
    let env           = fileInput.data("env");
    let primaryColor  = fileInput.data("primary-color");
    let accountUrl    = fileInput.data("account-url");
    var progressCont  = $(this).closest('.supporting-documentation').find('.file-upload-progress');
    var progressBar   = $("<div class='bar'></div>");
    var barContainer  = $("<div class='progress'></div>").append(progressBar);
    progressCont.append(barContainer);
    const allowedExtensions = [
      'txt', 'pdf', 'doc', 'docx', 'pptx', 'xls', 'xlsx', 'csv', 'html', 'htm'
    ];

    fileInput.fileupload({
      dropZone:         dropZone,
      fileInput:        fileInput,
      url:              fileInput.data('url'),
      type:             'POST',
      autoUpload:       true,
      formData:         fileInput.data('form-data'),
      paramName:        'file', // S3 does not like nested name fields i.e. name="user[avatar_url]"
      dataType:         'XML',  // S3 returns XML if success_action_status is set to 201
      replaceFileInput: false,
      add: function (e, data) {
        // Validate file extension
        const file = data.files[0];
        const fileName = file.name || '';
        const ext = fileName.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(ext)) {
          const displayExtensions = allowedExtensions.map(ext => '.' + ext).join(', ');
          ToastCustom({
            title: 'File type not allowed',
            message: 'File type not allowed. Allowed types are: <br />' + displayExtensions,
            delay: 7000,
            type: 'warning'
          });
          return false;
        }
        // Proceed with upload
        $(this).fileupload('send', data);
      },
      progressall: function (e, data) {
        var progress = parseInt(data.loaded / data.total * 100, 10);
        progressBar.css('width', progress + '%')
      },
      start: function (e) {
        barContainer.css("height", "25px");
        progressBar.
          css('background', primaryColor).
          css('display', 'block').
          css('width', '0%').
          css("height", "25px");
        progressCont.removeClass('d-none');
      },
      done: function(e, data) {
        progressBar.text("");

        // extract key from response
        let key = $(data.jqXHR.responseXML).find("Key").text();
        let accountUrl = filePicker.attr('data-account-url');
        let answerId = filePicker.attr('data-answer-id');

        // Set card body to indicate value changed for reloading page
        let cardBody = $(this).closest('.card-body.survey-card-body');
        cardBody.attr('data-val-changed', 'true');

        // Set spinner so user knows in progress
        cardBody.addClass('opaque');
        Spinner($(this).closest('.card'));

        // Upload file
        let url = "/" + accountUrl + '/surveys/' + surveySlug + '/documents';
        let formData = {}
        formData['file'] = {}
        formData['file']['key'] = key;
        formData['answer_id'] = answerId;

        // Toggle new data so doc gets sent with save
        ToggleNewData(fileInput);

        // Update documents count indicator
        let documentsCountSpan = filePicker.closest('.question-row').find('.uploaded-documents-count');
        if (documentsCountSpan.length !== 0) {
          let currentCount = parseInt(documentsCountSpan.text().replace('(', '').replace(')', '')) || 0;
          documentsCountSpan.text('(' + (currentCount + 1) + ')');
          documentsCountSpan.removeClass('d-none');
        }

        // Update local attribute
        return $.ajax({
          type: 'POST',
          url: url,
          dataType: "script",
          data: formData
        });

      },
      fail: function(e, data) {
        progressBar.
          css("background", "red").
          text("Failed");
      }
    });
  });

}
